import React from "react";
import { useTranslation } from "react-i18next";
import { StoreSubType } from "../../../types/modules/admin/storeType.type";
import StoreSubTypeItem from "./StoreSubTypeItem";
// import StoreTypeItem from "./StoreTypeItem";

interface Props {
  subTypes: StoreSubType[];
}

const StoreSubTypesTable: React.FC<Props> = ({ subTypes }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal capitalize">{t("id")}</th>
            <th className="p-3 font-normal capitalize">{t("name_in_english")}</th>
            <th className="p-3 font-normal capitalize">{t("name_in_arabic")}</th>
            <th className="p-3 font-normal capitalize">{t("actions")}</th>
          </tr>
        </thead>
        <tbody className="text-sm">
          {subTypes.map((subType, index) => (
            <tr
              key={subType.id}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >
                <StoreSubTypeItem subType={subType}/>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default StoreSubTypesTable;